(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5383],{

/***/ 95383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content054": function() { return /* binding */ Content054; },
  "default": function() { return /* binding */ Content054_Content054; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
// EXTERNAL MODULE: ./src/components/GoogleMap/GoogleMap.module.scss
var GoogleMap_module = __webpack_require__(57050);
var GoogleMap_module_default = /*#__PURE__*/__webpack_require__.n(GoogleMap_module);
;// CONCATENATED MODULE: ./src/components/GoogleMap/useScript.js

var useScript = function(src) {
    var ref = (0,react.useState)(src ? "loading" : "idle"), status = ref[0], setStatus = ref[1];
    (0,react.useEffect)(function() {
        if (!src) {
            setStatus("idle");
            return;
        }
        var script = document.querySelector('script[src="'.concat(src, '"]'));
        if (!script) {
            script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.setAttribute("data-status", "loading");
            document.body.appendChild(script);
        } else {
            setStatus(script.getAttribute("data-status"));
        }
        var setStateFromEvent = function(event) {
            setStatus(event.type === "load" ? "ready" : "error");
        };
        script.addEventListener("load", setStateFromEvent);
        script.addEventListener("error", setStateFromEvent);
        return function() {
            if (script) {
                script.removeEventListener("load", setStateFromEvent);
                script.removeEventListener("error", setStateFromEvent);
            }
        };
    }, [
        src
    ]);
    return status;
};
/* harmony default export */ var GoogleMap_useScript = (useScript);

;// CONCATENATED MODULE: ./src/components/GoogleMap/GoogleMap.jsx





var GoogleMap = function(param) {
    var lat = param.lat, lng = param.lng;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,Global/* useGlobalState */.j1)(), googleMapsApiKey = ref1.googleMapsApiKey, googleMapsPinImage = ref1.googleMapsPinImage;
    var status = GoogleMap_useScript("https://maps.googleapis.com/maps/api/js?key=".concat(googleMapsApiKey));
    (0,react.useEffect)(function() {
        if (status === "ready" && ref.current) {
            var map = new window.google.maps.Map(ref.current, {
                center: {
                    lat: lat,
                    lng: lng
                },
                zoom: 13,
                disableDoubleClickZoom: true,
                mapTypeControl: false,
                scaleControl: true,
                scrollwheel: false,
                panControl: true,
                streetViewControl: false,
                draggable: true,
                overviewMapControl: true,
                overviewMapControlOptions: {
                    opened: false
                },
                styles: [
                    {
                        stylers: [
                            {
                                saturation: -200
                            }, 
                        ]
                    }, 
                ]
            });
            new window.google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                },
                map: map,
                icon: googleMapsPinImage.url
            });
        }
    }, [
        googleMapsPinImage,
        lat,
        lng,
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (GoogleMap_module_default()).map,
        ref: ref
    });
};

;// CONCATENATED MODULE: ./src/components/GoogleMap/index.js


// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/widgets/content/Content054/Content054.module.scss
var Content054_module = __webpack_require__(87008);
var Content054_module_default = /*#__PURE__*/__webpack_require__.n(Content054_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content054/Content054.jsx




var Content054 = function(param) {
    var payload = param.payload;
    var ref;
    var lng = (ref = payload === null || payload === void 0 ? void 0 : payload.longitude) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var lat = (ref1 = payload === null || payload === void 0 ? void 0 : payload.latitude) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var image = (ref2 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref2 !== void 0 ? ref2 : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content054_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Content054_module_default()).block,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap, {
                    lat: lat,
                    lng: lng
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: image,
                    className: (Content054_module_default()).image
                })
            ]
        })
    });
};
/* harmony default export */ var Content054_Content054 = (Content054);


/***/ }),

/***/ 57050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"map":"GoogleMap_map__6nSei"};

/***/ }),

/***/ 87008:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content054_wrapper__LQArj","block":"Content054_block__2rgBR","image":"Content054_image__uM68f"};

/***/ })

}]);